"use strict";
/**
 * Response 403 - the client does not have access rights to the content;
 * that is, it is unauthorized, so the server is refusing to give the requested resource.
*/
const forbiddenError = class ForbiddenError extends Error {
    /**
     * @param {string} entityType required
     * @param {string} entityId optional
     */
    constructor(entityType, entityId) {
        const message = `Access to ${entityType}${entityId ? ` ${entityId}` : ''} is forbidden`;
        super(message);
        this.status = 403;
    }
    toString() {
        return this.message;
    }
};
module.exports = forbiddenError;
//# sourceMappingURL=forbiddenError.js.map